import { api } from '../api/client';
import { ResourceList } from '../components/ResourceList';
import { useT } from '../i18n/I18nProvider';

interface AddressPool {
  id: string;
  name: string;
  kind: string;
  family: string;
  cidr: string;
  linkPrefixLength: number | null;
  description: string | null;
}

export function AddressPoolsPage(): JSX.Element {
  const t = useT();

  return (
    <ResourceList<AddressPool>
      title={t('pool.title')}
      load={() => api.get<AddressPool[]>('/address-pools').then((items) => ({ items }))}
      columns={[
        { header: t('pool.name'), render: (r) => r.name },
        { header: t('pool.kind'), render: (r) => r.kind },
        { header: t('pool.family'), render: (r) => (r.family === 'IPV4' ? 'IPv4' : 'IPv6') },
        { header: t('pool.cidr'), render: (r) => <code>{r.cidr}</code> },
        {
          header: t('pool.linkPrefix'),
          render: (r) => (r.linkPrefixLength ? `/${r.linkPrefixLength}` : '—'),
        },
      ]}
      create={{
        label: t('common.create'),
        fields: [
          { name: 'name', label: t('pool.name'), required: true, placeholder: 'overlay-loopbacks' },
          {
            name: 'kind',
            label: t('pool.kind'),
            type: 'select',
            required: true,
            options: [
              { value: 'LOOPBACK', label: 'Loopback' },
              { value: 'POINT_TO_POINT', label: 'Point-to-point' },
              { value: 'ROUTER_ID', label: 'Router ID' },
              { value: 'TUNNEL', label: 'Tunnel' },
            ],
          },
          { name: 'cidr', label: t('pool.cidr'), required: true, placeholder: '10.255.0.0/16' },
        ],
        submit: (v) => api.post('/address-pools', v).then(() => undefined),
      }}
    />
  );
}
